import { Container, Section, PageHero, CtaBanner, ShieldCheck, CheckCircle2, TrustStrip } from "../components/common";
import { useSeo, breadcrumbLd, faqLd } from "../lib/seo";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../components/ui/accordion";

const COVER = [
 "24 months or 24,000 miles on qualifying parts and labor, whichever comes first",
 "Honored at thousands of NAPA AutoCare locations nationwide",
 "Peace of mind whether you're home in Riverside or on a road trip",
 "Backed by ASE Master Certified workmanship",
];
const FAQS = [
 { q: "What does your warranty cover?", a: "Qualifying repairs are covered under the NAPA AutoCare Peace of Mind Warranty for 24 months or 24,000 miles, whichever comes first, on both parts and labor. We'll confirm coverage details on your specific repair before work begins." },
 { q: "Is the warranty valid outside Riverside?", a: "Yes. One of the biggest advantages of our nationwide NAPA warranty is that it's honored at thousands of participating shops across the country, so you're protected even far from home." },
 { q: "How do I make a warranty claim?", a: "Simply bring your invoice back to us, or visit any participating NAPA AutoCare Center if you're out of the area. We make the process straightforward and stand behind our work." },
 { q: "Do you guarantee your workmanship?", a: "Absolutely. Our reputation since 1995 is built on doing the job right the first time. If something isn't right with a repair we performed, we'll make it right." },
];

export default function Warranty() {
 useSeo({
 title: "Nationwide Warranty | RPM Auto Repair Riverside",
 description: "RPM Auto Repair backs qualifying repairs with a nationwide 24-month/24,000-mile NAPA warranty. Honest, ASE-certified work you can trust. Call (951) 653-4777.",
 path: "/warranty",
 jsonLd: [breadcrumbLd([{ name: "Home", path: "/" }, { name: "Warranty", path: "/warranty" }]), faqLd(FAQS)],
 });
 return (
 <>
 <PageHero eyebrow="We Stand Behind Our Work" title="Nationwide Warranty Protection"
 subtitle="Every qualifying repair is backed by a nationwide NAPA warranty, good for 24 months or 24,000 miles, whichever comes first, and honored coast to coast."
 image="https://images.pexels.com/photos/5276374/pexels-photo-5276374.jpeg?auto=compress&cs=tinysrgb&w=1400"
 crumbs={[{ name: "Home", path: "/" }, { name: "Warranty", path: "/warranty" }]} />
 <TrustStrip />
 <Section>
 <Container className="grid items-center gap-12 lg:grid-cols-2">
 <div>
 <ShieldCheck className="text-primary" size={44} />
 <h2 className="mt-4 font-display text-3xl text-white">The NAPA Peace of Mind Warranty</h2>
 <p className="mt-4 leading-relaxed text-muted-foreground">As a NAPA AutoCare Center, RPM Auto Repair offers one of the strongest warranties in the industry. When we repair your vehicle, you don't just get quality workmanship, you get lasting protection that travels with you.</p>
 <p className="mt-4 leading-relaxed text-muted-foreground">It's our promise, in writing: honest diagnostics, quality parts, certified workmanship, and a warranty that has your back long after you leave our shop.</p>
 </div>
 <div className="rounded-2xl border border-primary/30 bg-gradient-to-br from-[#1a1013] to-steel p-8">
 <h3 className="font-display text-2xl text-white">What's Covered</h3>
 <ul className="mt-6 space-y-4">
 {COVER.map((c) => (
 <li key={c} className="flex items-start gap-3 text-white"><CheckCircle2 size={20} className="mt-0.5 shrink-0 text-primary" /> {c}</li>
 ))}
 </ul>
 </div>
 </Container>
 </Section>
 <Section className="bg-steel/40">
 <Container className="max-w-3xl">
 <h2 className="mb-8 font-display text-3xl text-white">Warranty FAQs</h2>
 <Accordion type="single" collapsible className="space-y-3">
 {FAQS.map((f, i) => (
 <AccordionItem key={i} value={`f${i}`} className="rounded-xl border border-white/10 bg-steel px-5">
 <AccordionTrigger className="text-left text-base text-white hover:no-underline">{f.q}</AccordionTrigger>
 <AccordionContent className="text-muted-foreground leading-relaxed">{f.a}</AccordionContent>
 </AccordionItem>
 ))}
 </Accordion>
 </Container>
 </Section>
 <CtaBanner />
 </>
 );
}
